import React from "react";
import {Button, Timeline} from "antd";
import moment from "moment";
import {Link, withRouter} from "react-router-dom";
import { formatMoney, formatExchangeRate, displayNumberWithComma } from "utils/utils";
import "./TrackAndTracePanel.scss";
import {downloadOrderReceipt} from "../api/api";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";
import {connect} from "react-redux";

class TimelineOrderBooking extends React.Component {
    downloadOrder = () => {
        downloadOrderReceipt('order',this.props.order.id, this.props.order.orderId);
    };
  render() {
    return (
      <Timeline className="track-and-trace-timeline">
        <Timeline.Item dot={<CompletedItemIcon />}>
          <span className="timeline-completed-item"><FormattedMessage id="app.panel.timelineorder.ordersetup"/></span>
          {this.props.order.dateCreated && (
            <div className="timeline-hint-label">
              <FormattedMessage id="app.panel.timelineorder.completedon"/>{" "}
              {moment(this.props.order.dateCreated).format("MMM DD, YYYY")}
            </div>
          )}
        </Timeline.Item>
        <Timeline.Item dot={<CompletedItemIcon />}>
          <span className="timeline-completed-item">
                <FormattedMessage id="app.panel.timelineorder.waitingpayment"/>
                &nbsp;&nbsp;&nbsp;&nbsp;<Button htmlType={"button"} size={"small"} type={"primary"} onClick={this.downloadOrder}>
                    <FormattedMessage id="app.panel.timelineorder.receipt"/>
                  </Button>
          </span>
            {(this.props.currentUser && !this.props.currentUser.role.readOnly &&
                (
                <div className="bp-small-bordered-panel mb-0">
                    <FormattedMessage id="app.message.timelineorder.yettomakepayment"/>{' '}<b>{this.props.order.sourceCurrency} {displayNumberWithComma(this.props.order.sourceAmount)}</b>,
                    <Link
                        // to={{ pathname:`/pages/transfer?currentStep=make-payment&sourceCurrency=${
                        //         this.props.order.sourceCurrency
                        //     }&sourceAmount=${this.props.order.sourceAmount}&targetCurrency=${
                        //         this.props.order.targetCurrency
                        //     }&targetAmount=${this.props.order.targetAmount}`, state: {order: this.props.order}}}
                        to={`/pages/transfer?currentStep=make-payment&sourceCurrency=${
                            this.props.order.sourceCurrency
                        }&sourceAmount=${this.props.order.sourceAmount}&targetCurrency=${
                            this.props.order.targetCurrency
                        }&targetAmount=${this.props.order.targetAmount}&order_id=${
                            this.props.order.id
                        }&orderId=${
                            this.props.order.orderId
                        }`}
                        onClick={() => {
                            localStorage.setItem("order", JSON.stringify(this.props.order));
                        }
                        }
                    >
                        {" "}
                        <FormattedMessage id="app.panel.timelineorder.clickhere"/>
                    </Link>
                </div>
                )
            )}

        </Timeline.Item>
        <Timeline.Item dot={<NotCompletedItemIcon />}>
          <span className="timeline-not-completed-item">
            <FormattedMessage id="app.panel.timelineorder.payouttobeneficiary"/>
          </span>
        </Timeline.Item>
        <Timeline.Item dot={<NotCompletedItemIcon />}>
          <span className="timeline-not-completed-item">
            <FormattedMessage id="app.panel.timelineorder.ordercompleted"/>
          </span>
        </Timeline.Item>
      </Timeline>
    );
  }
}

function CompletedItemIcon() {
    return <div className="timeline-dot-completed" />;
}

function NotCompletedItemIcon() {
    return <div className="timeline-dot-not-completed" />;
}

const mapStateToProps = state =>{
    return {
        currentUser: state.user.currentUser
    }
}

const mapDispatchToProps = dispatch =>{

}

export default withRouter(
    connect(mapStateToProps,mapDispatchToProps) (
        withUseIntl(TimelineOrderBooking)));
// export default withUseIntl(TimelineOrderBooking);